import styled from 'styled-components';
import { themeGet, getTextColor, getBackgroundColor } from '@magalu/stereo-ui-styles';
import Text from '../../atoms/Text';
import Flex from '../../atoms/Flex';
export const Container = styled(Flex)`
  display: flex;
  justify-content: ${props => props.carousel ? 'start' : 'center'};
  align-content: center;
  padding: 12px;
  overflow-x: scroll;
`;
export const Title = styled(Text)`
  color: ${props => getTextColor('scratched')(props)};
  display: block;
  margin-bottom: 8px;
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
`;
export const DeliveryContainer = styled(Flex)`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const DeliveryItem = styled(Flex)`
  scroll-snap-align: center;
  justify-content: center;
  align-items: center;
  padding: 4px 16px;
  line-height: 1.17;
  color: ${props => props.selected ? getTextColor('base')(props) : getTextColor('lightest')(props)};
  margin-right: 8px;
  background-color: ${props => props.selected ? getBackgroundColor('primary')(props) : getBackgroundColor('lighter')(props)};
  border-radius: 20px;
  height: 38px;

  > svg {
    margin-right: 4px;
    fill: ${props => props.selected ? getTextColor('lightest')(props) : getTextColor('base')(props)};
  }
  max-width: 144px;
`;
export const Label = styled(Text)`
  width: 81px;
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
  font-weight: ${props => themeGet('fontWeights.regular')(props)};
  font-stretch: normal;
  font-style: normal;
  line-height: ${props => themeGet('lineHeights.standard')(props)}px;
  letter-spacing: normal;
  height: auto;
  color: ${props => props.selected ? getTextColor('lightest')(props) : getTextColor('base')(props)};
`;